import DeleteAccountModalFlow from 'pages/profile/components/ProfileTabContent/Account/Advanced/components/DeleteAccountModalFlow';
import ProfileEditableTable from 'pages/profile/components/ProfileTabContent/components/ProfileEditableTable';
import ProfileSection from 'pages/profile/components/ProfileTabContent/components/ProfileSection';
import { useState } from 'react';
import classes from './index.module.scss';

const Advanced = () => {
  const [deleteAccountModalOpen, setDeleteAccountModalOpen] = useState(false);

  return (
    <ProfileSection title={'Advanced Settings'}>
      <ProfileEditableTable
        data={[
          {
            key: 'Deactivate Account',
            keyClassName: classes.deleteAccount,
            value: null,
            onClickKey: () => setDeleteAccountModalOpen(true),
          },
        ]}
      />
      <DeleteAccountModalFlow
        isOpen={deleteAccountModalOpen}
        onClose={() => setDeleteAccountModalOpen(false)}
      />
    </ProfileSection>
  );
};

export default Advanced;
